import { useState, useEffect } from 'react';
import { normalizeVertical } from '@/help/verticalKeys';
import api from '@/lib/api';

const CACHE_KEY = 'cavernicol_tenant_vertical';

export default function useTenantVertical() {
  const [vertical, setVertical] = useState(() => {
    try { return sessionStorage.getItem(CACHE_KEY) || 'generic'; } catch { return 'generic'; }
  });

  useEffect(() => {
    api.get('/tenant/profile').then(r => {
      const v = normalizeVertical(r.data?.vertical);
      setVertical(v);
      try { sessionStorage.setItem(CACHE_KEY, v); } catch {}
    }).catch(() => {});
  }, []);

  return vertical;
}
